<!--  -->
<template>
    <div class="ditch">
        <!-- 未开通 -->
        <div class="padding-20 notAvailable bgc box-shadow" v-if="!ischannel">
            <div class="left">
                <img :src="require('@/common/images/agencyService/notAvailable.png')" alt="">
            </div>
            <div class="right">
                <div class="msg">
                    <div class="title">渠道管理</div>
                    <div class="tips">开通渠道功能后，机构可以使用资鲸平台上的相应资源，同时根据资源的不同配置获取到对应的收益。</div>
                    <div class="price">免费</div>
                </div>
                <div class="btn">
                    <el-button @click="nowOpen">立即开通</el-button>
                </div>
            </div>
        </div>
        <!-- 已开通 -->
        <div class="haveOpened" v-if="ischannel">
            <!-- 渠道地址 -->
            <div class="ditchAddress padding-20 bgc box-shadow">
                <p class="title">您的渠道功能已开通</p>
                <div class="address">
                    课程渠道地址：
                    <el-input disabled v-model="ordermsg.courseurl"></el-input>
                    <el-button type="primary" v-clipboard:copy="ordermsg.courseurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                    <el-button type="primary" @click="openShare">分享</el-button>
                </div>
            </div>
            <!-- 订单 金额 佣金 -->
            <div class="order">
                <div class="item box-shadow">
                    <div class="title">订单总数</div>
                    <div class="value">{{ordermsg.ordercount}}<span>笔</span></div>
                </div>
                <div class="item box-shadow">
                    <div class="title">订单总额</div>
                    <div class="value">{{ordermsg.ordertotal}}<span>元</span></div>
                </div>
                <div class="item box-shadow">
                    <div class="title">佣金总额</div>
                    <div class="value">{{ordermsg.brokeragebychannel}}<span>元</span></div>
                </div>
            </div>
            <!-- 列表版块 -->
            <div class="listBox padding-20 bgc box-shadow">
                <div class="search">
                    <div class="date">
                        <div>订单时间段</div>
                        <el-date-picker unlink-panels value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="params.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                    <div class="type">
                        <div>内容类型</div>
                        <el-select v-model="params.kmctype" placeholder="请选择">
                            <el-option v-for="item in typelist" :key="item.name" :label="item.name" :value="item.type"></el-option>
                        </el-select>
                    </div>
                    <div class="key">
                        <div class="name">搜索关键字</div>
                        <el-input v-model="params.kmcname" placeholder="输入订单号、名称"></el-input>
                    </div>
                    <div class="btn">
                        <el-button @click="triggerSearch">搜索</el-button>
                        <el-button @click="triggerReset">重置</el-button>
                    </div>
                </div>
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="name" label="商品名称">
                        <template slot-scope="scope">
                            <div class="nameCoverType">
                                <div class="cover"><img :src="scope.row.coverurl" alt=""></div>
                                <div class="nameType">
                                    <div class="name">{{scope.row.kmcname}}</div>
                                    <div>
                                        <div class='type'>
                                            {{scope.row.kmctypename}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderno" class-name="center" label="订单号" width="200"></el-table-column>
                    <el-table-column prop="datetime" class-name="center" label="订单时间" width="160"></el-table-column>
                    <el-table-column prop="finalpaymoney" class-name="center" label="订单金额" width="120"></el-table-column>
                    <el-table-column prop="channelmoney" class-name="center" label="渠道佣金" width="120"></el-table-column>
                    <el-table-column prop="customername" class-name="center" label="买家昵称" width="80"></el-table-column>
                </el-table>
                <Page :total="total" @getList="_getList" ref="page" />
            </div>
        </div>
        <OpenDialog ref="openDialog" />
        <Share ref="share" />
    </div>
</template>

<script>
import Page from 'base/page/page'
import OpenDialog from './openDialog'
import Share from './share'
import {getOrderList} from 'api/channel'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            ordermsg: {
                ordercount: '',
                ordertotal: '',
                brokeragebychannel: '',
                courseurl: ''
            },
            ischannel: 0,
            total: 0,
            params: {
                date: [],
                kmctype: '',
                kmcname: '',
                begintime: '',
                endtime: '',
                page: 1,
                pageSize: 10
            },
            typelist: [
                {name: '图文', type: 1},
                {name: '报告', type: 2},
                {name: '直播', type: 3},
                {name: '视频', type: 4},
                {name: '专题', type: 5},
                {name: '音频', type: 6},
                {name: '课程', type: 7},
                {name: '题库', type: 8},
                {name: '星球', type: 11},
                {name: '活动', type: 12},
                {name: '报名活动', type: 13}
            ],
            tableData: []
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getOrderList()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        openShare() {
            this.$refs.share.open(this.ordermsg.courseurl)
        },
        onCopy() {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            this.$message({
                message: '复制失败',
                type: 'success'
            })
        },
        // 触发搜索
        triggerSearch() {
            if (this.params.date.length) {
                this.params.begintime = this.params.date[0]
                this.params.endtime = this.params.date[1]
            }
            this.params.page = 1
            this.getOrderList()
        },
        //  触发重置
        triggerReset() {
            this.params = {
                date: [],
                type: '',
                key: '',
                begintime: '',
                endtime: '',
                page: 1,
                pageSize: 10
            }
            this.getOrderList()
        },
        _getList(page) {
            this.params.page = page.page
            this.getOrderList()
        },
        getOrderList() {
            this.setLoading(true)
            getOrderList({
                data: this.params,
                success: res => {
                    this.ischannel = res.data.ischannel
                    if(this.ischannel == 1){
                        this.total = res.data.pageinfo.rowCount
                        if (this.params.page === 1) {
                            this.ordermsg.courseurl = res.data.courseurl
                            this.ordermsg.ordercount = res.data.ordercount
                            this.ordermsg.ordertotal = res.data.ordertotal
                            this.ordermsg.brokeragebychannel = res.data.brokeragebychannel
                        }
                        this.tableData = res.data.content   
                    }
                    this.setLoading(false)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        nowOpen() {
            this.$refs.openDialog.open()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        Page,
        OpenDialog,
        Share
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .ditch {
        // 未开通
        .notAvailable {
            display: flex;
            align-items: center;
            .left {
                width: 140px;
                height: 140px;
                margin-right: 24px;
                img {
                    width: 140px;
                    height: 140px;
                }
            }
            .right {
                height: 140px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .msg {
                    .title {
                        font-size: 24px;
                        font-weight: bold;
                        margin-bottom: 10px;
                    }
                    .tips {
                        font-size: 14px;
                        color: #606266;
                        line-height: 18px;
                        margin-bottom: 6px;
                    }
                    .price {
                        font-size: 16px;
                        color: #409EFF;
                    }
                }
                .btn {
                    .el-button {
                        width: 96px;
                        height: 32px;
                        background: #409EFF;
                        color: #fff;
                    }
                }
            }
        }
        // 已开通
        .haveOpened {
            .ditchAddress {
                margin-bottom: 24px;
                .title {
                    margin-bottom: 20px;
                }
                .address {
                    display: flex;
                    align-items: center;
                    .el-input {
                        width: 380px;
                        margin: 0 20px;
                    }
                    .el-button {
                        width: 58px;
                        min-width: 58px;
                    }
                }
            }
            .order {
                display: flex;
                align-items: center;
                margin-bottom: 24px;
                .item {
                    height: 120px;
                    flex: 1;
                    background: #fff;
                    padding: 30px 50px;
                    box-sizing: border-box;
                    .title {
                        font-size: 14px;
                        color: #303133;
                        margin-bottom: 16px;
                    }
                    .value {
                        font-size: 24px;
                        color: #409EFF;
                        line-height: 28px;
                    }
                    &:not(:last-of-type) {
                        margin-right: 40px;
                    }
                }
            }
            .listBox {
                .search {
                    display: flex;
                    align-items: center;
                    margin-bottom: 30px;
                    .date, .type, .key {
                        display: flex;
                        align-items: center;
                    }
                    .date {
                        margin-right: 20px;
                        .el-date-editor {
                            margin-left: 10px;
                            width: 240px;
                            .el-input__icon, .el-range-separator {
                                line-height: 24px;
                            }
                        }
                    }
                    .type {
                        margin-right: 20px;
                        .el-select {
                            width: 150px;
                            margin-left: 10px;
                            .el-select__caret {
                                line-height: 32px;
                            }
                        }
                    }
                    .key {
                        margin-right: 20px;
                        .name {
                            width: 70px;
                        }
                        .el-input {
                            width: 150px;
                            margin-left: 10px;
                        }
                    }
                }
                .el-table {
                    .center {
                        .cell {
                            text-align: center;
                        }
                    }
                    .nameCoverType {
                        display: flex;
                        align-items: center;
                        .cover {
                            width: 106px;
                            height: 60px;
                            margin-right: 10px;
                            img {
                                width: 106px;
                                height: 60px;
                            }
                        }
                        .nameType {
                            height: 60px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .name {
                                font-size: 14px;
                                width: 304px;
                                line-height: 18px;
                                text-overflow: -o-ellipsis-lastline;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                            .type {
                                color: #fff;
                                display: inline-block;
                                padding: 0 6px;
                                height: 18px;
                                text-align: center;
                                line-height: 18px;
                                font-size: 12px;
                                border-radius: 2px;
                                background-color: #909399;
                            }
                            // .type1 {
                            //     background-color: #909399;
                            // }
                            // .type2 {
                            //     background-color: #E6A23C;
                            // }
                            // .type3 {
                            //     background-color: #409EFF;
                            // }
                            // .type4 {
                            //     background-color: #67C23A;
                            // }
                            // .type5 {
                            //     background-color: #F56C6C;
                            // }
                        }
                    }
                }
            }
        }
    }
</style>